import React, { useState } from "react";
import axios from "axios";
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
} from 'reactstrap';

const HeaderDropdown = (props) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const logOut = e => {

        axios.all([
            axios.get(process.env['REACT_APP_API_URL'] + "/upward/logout.jsp"),
        ])
        .then(responseArr => {
			document.location.reload();
        }, (error) => {
            console.log(error);
        });

    }

	return (
		<Dropdown className="upward_header_dropdown" isOpen={dropdownOpen} toggle={toggle}>
			<DropdownToggle className="upward_header_dropdown_toggle">
		  		<span>Me</span> 
		     	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		      		<polyline points="6 9 12 15 18 9"></polyline>
		      	</svg>
		  	</DropdownToggle>
		  	<DropdownMenu right>
				<DropdownItem tag="a" href={`${props.redirectBaseUrl}/results`}>Search for jobs</DropdownItem>
				<DropdownItem tag="a" href={`${props.redirectBaseUrl}/e/profile`}>My Profile</DropdownItem>
				<DropdownItem tag="a" href={`${props.redirectBaseUrl}/e/myRecentSearches`}>Job Alerts</DropdownItem>
				<DropdownItem tag="a" href={`${props.redirectBaseUrl}/e/recommended-jobs`}>Applied/Viewed Jobs</DropdownItem>
				<DropdownItem tag="a" href="#" onClick={logOut}>Logout</DropdownItem>
			</DropdownMenu>
		</Dropdown>
	)
}

export default HeaderDropdown;

